import Images from "@Theme/Images";
import Styles from "./styles.module.scss";
import Checkbox from "@Atom/Checkbox";
import { useState } from "react";
import Icon from "@Atom/Icon";
import { useDropzone } from "react-dropzone";
import ProgressBar from "@Atom/ProgressBar";
import InputField from "@Molecule/InputField";
import Spinner from "@Atom/Spinner";

export default function FraudAlertModal({
  setIsChecked = () => {},
  isChecked = false,
  handleBack = () => {},
  files,
  setfiles = () => {},
  desc,
  setDesc = () => {},
  handleClose = () => {},
  handleSubmit = () => {},
  error = "",
  loadingFraud = false,
}) {
  const [step, setStep] = useState("");

  const [isUploading, setIsUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles?.length > 0) {
      if (
        acceptedFiles[0]?.type === "image/jpeg" ||
        acceptedFiles[0]?.type === "image/jpg" ||
        acceptedFiles[0]?.type === "image/png" ||
        acceptedFiles[0]?.type === "application/pdf"
      ) {
        setfiles(acceptedFiles[0]);
        setIsUploading(true);
      } else {
        setfiles(null);
        setIsUploading(false);
      }
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "application/pdf": [".pdf"],
      "image/jpeg": [],
      "image/jpg": [],
      "image/png": [],
    },
    multiple: false,
    // maxSize: 1048576 * 5,
  });

  return !step ? (
    <div className={Styles.container}>
      <div className={Styles.images}>
        <img src={Images.FRAUD_ALERT_IMAGE} alt="" />
      </div>

      <div className={Styles.descBox}>
        <span className={Styles.H1}>Waspada Penipuan!</span>
        <span className={Styles.span}>
          Permata Indonesia tidak pernah meminta imbalan berupa apa pun. Mohon
          laporkan kepada kami apabila anda menjumpai praktik tersebut.
        </span>
      </div>

      <div className={Styles.question}>
        Apakah Anda merasa pernah diminta memberikan imbalan?
      </div>

      <div className={Styles.buttonWrapper}>
        <div className={Styles.checkBox}>
          <Checkbox
            setIsChecked={setIsChecked}
            isChecked={isChecked}
            type={"job-post"}
          />
          <span className={Styles.span}>
            Jangan tampilkan informasi ini lagi hari ini.
          </span>
        </div>

        <button
          className={Styles.blue}
          onClick={() => {
            setStep("form");
          }}
        >
          Ya, saya pernah
        </button>
        <button className={Styles.transparant} onClick={handleBack}>
          Tidak pernah
        </button>
      </div>
    </div>
  ) : (
    <div className={Styles.containerForm}>
      <div className={Styles.header}>
        <span className={Styles.span}>Buat Laporan</span>
        <Icon
          icon={"cross"}
          size={24}
          className={Styles.cross}
          onClick={handleClose}
        />
      </div>

      <div className={Styles.content}>
        <div className={Styles.descBox}>
          <span className={Styles.spanBold}>Upload Bukti Pengaduan</span>
          <span className={Styles.span}>
            Upload foto atau dokumen sebagai bukti pengaduan anda
          </span>
        </div>

        <div className={Styles.form}>
          <span className={Styles.spanGrey}>Taruh file di kotak bawah ini</span>

          {files ? (
            <div className={Styles.previewBox}>
              <div className={Styles.left}>
                <div>
                  <Icon icon={"file"} size={24} />
                </div>
                <div>
                  <span className={Styles.title}>{files?.name || "-"}</span>
                  {isUploading && (
                    <ProgressBar
                      progress={progress}
                      handleProgress={() => {
                        setTimeout(function () {
                          setIsUploading(false);
                        }, 500);
                      }}
                      running={isUploading}
                      speed={30}
                    />
                  )}
                </div>
              </div>

              <div
                className={Styles.right}
                onClick={() => {
                  setfiles(null);
                  setProgress(0);
                }}
              >
                <Icon icon={"x-circle"} size={16} color={"#000"} />
              </div>
            </div>
          ) : (
            <div className={Styles.filesBox} {...getRootProps()}>
              <div className={Styles.iconDwonload}>
                <Icon icon={"upload"} size={40} color={"#C2C2C2"} />
              </div>

              <span className={Styles.spanBold}>
                Drag file ke sini untuk upload
              </span>
              <span className={Styles.spanGrey}>atau pilih file dengan</span>
              <span className={Styles.spanBlue}>Klik di sini</span>

              <input
                {...getInputProps()}
                disabled={false}
                type="file"
                // ref={inputCvRef}
                name="file"
                // onChange={onFileChange}
                hidden
              />
            </div>
          )}
        </div>

        <div className={Styles.form}>
          <span className={Styles.spanBold}>
            Penjelasan <span>*</span>
          </span>

          <InputField
            type="desc"
            value={desc}
            onChange={(e) => setDesc(e.target.value)}
            placeholder={"Masukan penjelasan disini"}
          />
        </div>
      </div>

      <div className={Styles.buttonWrapper}>
        {/* <span>*error</span> */}
        {error && <span>*error</span>}
        <div className={Styles.button}>
          <button disabled={loadingFraud} onClick={handleClose}>
            Batal
          </button>
          <button
            disabled={!files || !desc || isUploading || loadingFraud}
            onClick={handleSubmit}
          >
            {loadingFraud ? <Spinner /> : "Kirim"}
          </button>
        </div>
      </div>
    </div>
  );
}
